<template>
  <div id="addJiKeng">
    <el-dialog title="添加结构" :visible.sync="dialogAdd.show" @close="closeDialog()" width="620px" ref="dialog"
               @opened="opened()" :modal-append-to-body="false" :modal="false">
      <el-form ref="formAdd" :model="jikengData" label-width="80px">
        <input type="hidden" name="pitNo">
        <div style="width: 280px; float: left;">
          <div class="form-group">
            <label>所属项目</label>
            <el-select v-model="projectName" value-key="id" class="select" @change="selectProjectId">
              <el-option v-for="item in this.pInfo" :key="item.id" :label="item.name" :value="item"></el-option>
            </el-select>
          </div>
          <div class="form-inline">
            <div class="form-group">
              <label>类型:</label>
              <el-select v-model="typeName" value-key="id" class="select" @change="selectType">
                <el-option v-for="item in this.types" :key="item.id" :label="item.value" :value="item"></el-option>
              </el-select>
            </div>
          </div>
          <div class="form-inline">
            <div class="form-group">
                <label>结构描述</label>
                <el-input v-model="jikengData.description"></el-input>
            </div>
          </div>
          <div class="form-inline">
            <div class="form-group">
              <label>系统:</label>
              <el-select v-model="systemTypeName" value-key="id" class="select" @change="selectSystemType">
                <el-option v-for="item in this.systems" :key="item.id" :label="item.value" :value="item"></el-option>
              </el-select>
            </div>
          </div>
          <!-- <div class="form-group">
            <label>结构模型文件</label> <img id="imgview" style="width: 280px" src="../../assets/image/add_bg.png"><br />
                            <el-button type="primary" size="small">选择文件</el-button>
              <input type="file" name="modalfile" style="display: none">
          </div> -->
          <div class="pics" v-if="show2D">
            <label>2D图片</label>
            <el-upload
              :before-upload="beforeAvatarUpload"
              list-type="picture"
              :on-preview="handlePictureCardPreview"
              :limit="1"
              :multiple="true"
              accept=".jpg,.png"
              action="/api/monitor/fileUpload/uploadImage"
              :data="uploadData"
              :on-exceed="handleExceed"
              :on-success="handleAvatarSuccess"
              :on-remove="handleRemove"
              :file-list="fileList">
              <el-button size="small" type="primary">上传图片</el-button>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </div>
          <div class="form-group" v-if="show3D">
            <label>3D编号</label>
            <el-input v-model="bimfaceModelId"></el-input>
          </div>
        </div>

        <div style="width: 280px; float: right;">
          <div class="form-group">
            <label>结构名称</label>
            <el-input v-model="jikengData.name"></el-input>
          </div>
          <div class="form-group">
            <label>坐标选取</label>
            <div id="r-result">输入搜索:<input type="text" id="suggestId" size="40" @change="changeLat()" value="" style="width:180px;"/></div>
            <div id="searchResultPanel" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
            <div id="map"></div>
            <div>
              经度：<span id="lng">{{ lng }}</span>
              纬度：<span id="lat">{{ lat }}</span>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAdd.show = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('formAdd')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'addChildProject',
  props: {
    dialogAdd: Object, //接受父组件传递给子组件的数据
    pInfo: {
      Type: Array,
      default: () => []
    },
    types: {
      Type: Array,
      default: () => []
    },
    systems: {
      Type: Array,
      default: () => []
    }
  },
  data() {
    return {
      projectName: '', // 所属项目
      typeName: '', // 类型
      systemTypeName: '', // 系统默认未2D
      lng: '',
      lat: '',
      bimfaceModelId: '',
      jikengData: {
        projectId: '',
        type: '',
        name: '',
        coordinate: '',
        systemType: '1',
        description:'',
      },


      imageUrl: '',
      uploadData: { //上传文件时要上传的额外参数
        // userId: 'U0001',
        // userName: 'admin'
      },
      fileList: [],
      form: {
        docFile: [],
      },
      formDate: '',
      fd: '', //向服务器进行传递的参数（带有图片formdata）
      image_str: '',
      dialogImageUrl: '',
      dialogVisible: false,
      show2D: true,
      show3D: false,
    }
  },
  mounted: function () {

  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.image_str = res.datas.values
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('上传图片不能超过2M');
      }
      return isLt2M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多只能上传一张图片!`);
    },
    handlePictureCardPreview(file) {
        console.log(file,'预览')
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      // 删除功能，拼接的字符串中如果包含url,直接去掉此url
      if (this.image_str.includes(file.response)) {
        this.image_str = this.image_str.replace(`${file.response}_`, '');
      }
    },
    opened() {
        function G(id) {
            return document.getElementById(id);
        }
      // this.map = new BMap.Map("map");
      var map = new BMap.Map("map");
      map.disableAutoResize();
      let point = new BMap.Point(104.07, 30.67); // 默认设为成都的经纬度坐标
        map.centerAndZoom(point, 12);
        map.enableScrollWheelZoom(true);
        var ac = new BMap.Autocomplete(    //建立一个自动完成的对象
            {"input" : "suggestId"
                ,"location" : map
            });
        ac.addEventListener("onhighlight", function(e) {  //鼠标放在下拉列表上的事件
            var str = "";
            var _value = e.fromitem.value;
            var value = "";
            if (e.fromitem.index > -1) {
                value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
            }
            str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;

            value = "";
            if (e.toitem.index > -1) {
                _value = e.toitem.value;
                value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
            }
            str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
            G("searchResultPanel").innerHTML = str;
        });

        var myValue;
        ac.addEventListener("onconfirm", function(e) {    //鼠标点击下拉列表后的事件
            // console.log(local.getResults().getPoi(0).point)
            var _value = e.item.value;
            myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
            G("searchResultPanel").innerHTML ="onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
            setPlace();
        });
        function setPlace() {
            map.clearOverlays();    //清除地图上所有覆盖物
            function myFun() {
                var pp = local.getResults().getPoi(0).point;    //获取第一个智能搜索的结果
                map.centerAndZoom(pp, 12);
                map.addOverlay(new BMap.Marker(pp));    //添加标注
            }
            var local = new BMap.LocalSearch(map, { //智能搜索
                onSearchComplete: myFun
            });
            local.search(myValue);
        }
      const _this = this
      //单击获取点击的经纬度
        map.addEventListener("click", function (e) {
        map.clearOverlays();
        map.addOverlay(new BMap.Marker(e.point));    //添加标注
        _this.lng = e.point.lng;
        _this.lat = e.point.lat;
        this.lng = e.point.lng;
        this.lat = e.point.lat;
      });
    },
      changeLat(){
        setTimeout(()=>{
            this.lng ='';
            this.lat = '';
        },100)
      },
    selectProjectId(event) {
      this.jikengData.projectId = event.id;
    },
    selectType(e) {
      this.jikengData.type = e.id;
    },
    selectSystemType(e) {
      this.jikengData.systemType = e.id;
      if (e.id == 2) {
        this.show2D = true;
        this.show3D = false;
      } else {
        this.show3D = true;
        this.show2D = false;
      }
    },
    closeDialog() {
      this.dialogAdd.show = false;
      this.jikengData = {};
    },
    submitForm(ruleForm) {
      if (!this.jikengData.projectId) {
        this.$message({
          type: "warning",
          message: "请选择所属项目",
        });
        return
      }
      if (!this.jikengData.name) {
        this.$message({
          type: "warning",
          message: "请填写结构名称",
        });
        return
      }
      if (!this.jikengData.type) {
        this.$message({
          type: "warning",
          message: "请选择项目类型",
        });
        return
      }
      if (!this.jikengData.systemType) {
        this.$message({
          type: "warning",
          message: "请选择系统",
        });
        return
      }
      if (!this.lng || !this.lat) {
        this.$message({
          type: "warning",
          message: "请选择坐标",
        });
        return
      }
      if (this.jikengData.systemType === "1") {
        this.jikengData.bimfaceModelId = this.bimfaceModelId;
      } else {
        this.jikengData.projectPicPath = this.image_str
      }

      this.jikengData.coordinate = `${this.lng},${this.lat}`
      this.$axios.post('/api/monitor/project/child/createChildProject', this.jikengData).then(res => {
        if (res.data.status == 200) {
          this.$message({
            type: "success",
            message: res.data.message,
            showClose: true
          });
          this.dialogAdd.show = false;
          this.$emit('update'); //子组件使用$emit触发父组件自定义事件
          this.jikengData = {}
        }
        return
      })
    }
  }
}
</script>

<style>

    #addJiKeng .el-dialog__header {
      text-align: center;
      padding: 20px 30px 10px;
      /*background-image: url('../../assets/img/modal_bg.png')*/
      background: linear-gradient(
        -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
      border-radius: 2.5px 2.5px 0px 0px;
      transition: unset;
    }
    #addJiKeng .el-dialog__body {
        padding: 10px 20px;
    }

    #addJiKeng .el-dialog__title {
      text-align: center;
        font-size: 18px;
        color: #fff;
    }

    #addJiKeng .el-select .el-input__inner{
        background: #FFF;
        color: #000;
    }

</style>

<style scoped>

#map {
  width: 280px;
  height: 280px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: inline-block;
  margin-bottom: 5px;
  font-weight: bold;
}

.select {
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/project/add-child-project-dialog.vue